/* eslint-disable */
import Oidc from 'oidc-client';
import 'babel-polyfill';
Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;
import toolFunction from '@/utils/toolFunction'
import systemInfo from '@/utils/systemInfo'
// 这种情况是 authority 和client_id 动态传入的, 这样在每次new SecurityService时 就必须把传递配置进来
export default class SecurityService {
  constructor(config, isInitEvents = true) {
    var mgr = new Oidc.UserManager({
      userStore: new Oidc.WebStorageStateStore({ store: window.sessionStorage }),// 不要动这个配置
      authority: config.authority,
      client_id: config.client_id,
      redirect_uri: window.location.origin + '/signin-oidc',// 登录成功的回调跳转地址
      response_type: 'id_token token',// 不要动这个配置
      scope: 'openid profile UserRight',// 不要动这个配置
      post_logout_redirect_uri: window.location.origin + '/signout-oidc',// 退出登录后回调跳转地址
      silent_redirect_uri: window.location.origin + '/silent-renew',// token续期的地址
      accessTokenExpiringNotificationTime: 10,// token过期前多少秒通知前端
      automaticSilentRenew: false,// 指示是否应该在访问令牌到期之前自动尝试更新访问令牌
      filterProtocolClaims: true,
      loadUserInfo: true,//控制是否从用户信息端点加载额外的身份数据以填充用户的profile
      monitorSession: false, // 当用户在 OP 执行注销时将引发事件
      extraQueryParams: {// 扩展参数 用于你的程序扩展,
        tenantPlat: "saas", // 这是租户平台
        tenant: '' // 租户code
      }
    })
    this.mgr = mgr
    var i = 0
    if (isInitEvents) {// 是否初始化事件
      // token续期后的事件,如果有需要,要在这里重新获取user里面的token设置的你需要的地方.你可以将user打印出来
      mgr.events.addUserLoaded(function (user) {
        console.log('New User Loaded：', arguments);
        // 将token缓存在本地
        const token = user.access_token
        console.log(`%c token 续期第:${++i}次:   ${token}`, 'color:#0f0;')
        // token续期后插入到 缓存中
        systemInfo.setToken(user.token_type + ' ' + user.access_token)
        toolFunction.postTokenToAllIframe()

      });
      // token快要过期时的事件:一般来说不用做什么
      mgr.events.addAccessTokenExpiring(function () {
        console.log('token过期前的回调函数：', arguments);
      });
      // token 过期后回调
      mgr.events.addAccessTokenExpired(function () {
        console.log('AccessToken Expired：', arguments);
        console.log('token已过期,即将跳转到登录');
        mgr.signoutRedirect().then(function (resp) {
          console.log('signed out', resp);
        }).catch(function (err) {
          console.log(err)
        })
      });
      // token续期失败的回调
      mgr.events.addSilentRenewError(function () {
        console.error('Silent Renew Error：', arguments);
      });
      // 联合注销的回调
      mgr.events.addUserSignedOut(function () {
        // 清楚缓存中的状态
        mgr.clearStaleState();
        console.log('被联合注销时的回调函数,一般来说会跳转到登录页面去重新登录!');
        console.log('UserSignedOut：', arguments);
        mgr.signoutRedirect().then(function (resp) {
          console.log('signed out', resp);
        }).catch(function (err) {
          console.log(err)
        })
      });
    }
  }

  /**
   *先去获取user 如果存在返回true 表示已经登录, null的时候表示未登录, 则跳转到登录进行登录
   */
  getSignedIn() {
    let self = this
    return new Promise((resolve, reject) => {
      this.mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(false)
        } else {
          return resolve(true)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }


  /**
   * 登录
   * 如果你客户端租户和平台是可以变化的, 那么在登录时就要动态传入,作为扩展参数, 否则你可以直接在new UserManager 里面的extraQueryParams直接配置
   * @param {*} parms
   */
  signIn(parms = {}) {
    parms.tenantPlat= "saas"
    const _parms = {
      extraQueryParams: parms
    }
    this.mgr.signinRedirect(_parms).catch(function (err) {
      console.log(err)
    })
  }
  // 注销
  signOut() {
    this.mgr.signoutRedirect().then((resp) => {
      // 清楚缓存中的垃圾信息
      this.mgr.clearStaleState();
      console.log('signed out', resp);
    }).catch(function (err) {
      console.log(err)
    })
  }
  // 重新获取token
  renewToken() {
    let self = this
    return new Promise((resolve, reject) => {
      this.mgr.signinSilent().then(function (user) {
        if (user == null) {
          self.signIn(null)
        } else {
          return resolve(user)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }
  /**
   * 获取登录信息,未登录到时候返回null
   */
  getUserInfo() {
    return new Promise((resolve, reject) => {
      this.mgr.getUser().then(function (user) {
        if (user == null) {
          return resolve(null)
        } else {
          return resolve(user)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }
  // Get the user who is logged in
  getUser() {
    let self = this
    return new Promise((resolve, reject) => {
      this.mgr.getUser().then(function (user) {
        if (user == null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/oidcServices/OidcServer.js